import client from './client';
import { createCategoryApi } from './categories';

const PATH = '/api/publications/publications/';

const list = (params = {}) => client.get(PATH, { params }).then((r) => r.data);
const detail = (slug) => client.get(`${PATH}${slug}/`).then((r) => r.data);

/** Build a multipart FormData payload for publication create/update. */
const toFormData = ({ title, description, category, author, pdfFile, coverImage, is_featured, is_active }) => {
  const fd = new FormData();
  if (title !== undefined) fd.append('title', title);
  if (description !== undefined) fd.append('description', description);
  if (category !== undefined && category !== null && category !== '') fd.append('category', category);
  if (author !== undefined) fd.append('author', author);
  if (pdfFile instanceof File) fd.append('pdf_file', pdfFile, pdfFile.name);
  if (coverImage instanceof File) fd.append('cover_image', coverImage, coverImage.name);
  if (is_featured !== undefined) fd.append('is_featured', is_featured ? 'true' : 'false');
  if (is_active !== undefined) fd.append('is_active', is_active ? 'true' : 'false');
  return fd;
};

/** Build a multipart payload for bulk publication upload (multiple PDFs). */
const toBulkFormData = ({ pdfFiles, coverImage, category, description, author, is_featured, is_active }) => {
  const fd = new FormData();
  (pdfFiles || []).forEach((file) => fd.append('pdf_files', file, file.name));
  if (coverImage instanceof File) fd.append('cover_image', coverImage, coverImage.name);
  if (category !== undefined && category !== null && category !== '') fd.append('category', category);
  if (description !== undefined) fd.append('description', description);
  if (author !== undefined) fd.append('author', author);
  if (is_featured !== undefined) fd.append('is_featured', is_featured ? 'true' : 'false');
  if (is_active !== undefined) fd.append('is_active', is_active ? 'true' : 'false');
  return fd;
};

export const publicationApi = {
  list,
  detail,

  create(payload, { onUploadProgress } = {}) {
    return client.post(PATH, toFormData(payload), { timeout: 0, onUploadProgress }).then((r) => r.data);
  },

  update(slug, payload, { onUploadProgress } = {}) {
    return client.patch(`${PATH}${slug}/`, toFormData(payload), { timeout: 0, onUploadProgress }).then((r) => r.data);
  },

  bulk(payload, { onUploadProgress } = {}) {
    return client.post(`${PATH}bulk/`, toBulkFormData(payload), { timeout: 0, onUploadProgress }).then((r) => r.data);
  },

  remove(slug) {
    return client.delete(`${PATH}${slug}/`).then((r) => r.data);
  },

  publish(slug) {
    return client.post(`${PATH}${slug}/publish/`).then((r) => r.data);
  },

  unpublish(slug) {
    return client.post(`${PATH}${slug}/unpublish/`).then((r) => r.data);
  },

  categories: createCategoryApi('publications'),
};
